import styled from 'styled-components';
import { mqDesktopNav } from '../utils/mediaQuery';
import { svgWidth } from './styled-utils';
import { ReactComponent as LogoLight } from '@/src/resources/logo-white.svg';

export const StyledLightLogo = styled(LogoLight)`
  width: 50px;
  display: block;
  line-height: 0;

  ${mqDesktopNav(`
    ${svgWidth('50px', 48, 48)};
  `)}
`;
